"use client";

import React from "react";
import { Castle, Library, Users, GraduationCap, Map, Shield } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const benefits = [{
  title: "Shared Infrastructure",
  description: "Centralized digital resources and enterprise-grade frameworks that empower every venture under the Eagle 47 umbrella.",
  icon: Castle
}, {
  title: "Cross-Platform Data",
  description: "Unified data intelligence across all portfolio companies, enabling predictive analytics and strategic decision-making.",
  icon: Library
}, {
  title: "Unified Capital",
  description: "Efficient capital allocation and smart-contracting liquidity pools that drive growth for all emerging systems.",
  icon: Users
}, {
  title: "Strategic Governance",
  description: "Disciplined management structures and high-authority oversight ensuring long-term vision and operational excellence.",
  icon: GraduationCap
}, {
  title: "Scalable IP",
  description: "A robust portfolio of intellectual property and digital infrastructure built for rapid expansion across global markets.",
  icon: Map
}, {
  title: "Smart Execution",
  description: "Precision-engineered smart contracts and automated business logic that define the next era of digital commerce.",
  icon: Shield
}];
export default function CommunityBenefits() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="142120" id="holding-synergy" className="py-24 dark bg-background text-foreground relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-30">
        <div className="absolute -top-[20%] -left-[10%] w-[50%] h-[50%] rounded-full bg-primary/10 blur-3xl" />
        <div className="absolute top-[60%] -right-[10%] w-[40%] h-[60%] rounded-full bg-primary/5 blur-3xl" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div ref={headerRef} className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold text-foreground mb-6 tracking-tighter uppercase">
            The Synergy of Eagle 47
          </h2>
          <p className="text-lg text-muted-foreground font-sans leading-relaxed">
            A unified ecosystem of shared infrastructure, cross-platform data intelligence, and strategic capital management designed for scalable ownership.
          </p>
        </div>

        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 transition-all duration-1000 delay-200 ease-out ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <Card key={index} data-index={index} className="bg-card/60 backdrop-blur-xl border-border/40 shadow-xl hover:shadow-2xl transition-all duration-500 group rounded-sm">
                <CardHeader className="pb-4">
                  <div className="mb-4 inline-flex items-center justify-center w-12 h-12 rounded-sm bg-primary/10 text-primary group-hover:bg-primary/20 group-hover:scale-105 transition-all duration-500">
                    <Icon className="w-6 h-6 stroke-[1.5]" />
                  </div>
                  <CardTitle className="font-default text-xl text-foreground font-bold tracking-tight uppercase">
                    {benefit.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground leading-relaxed font-sans text-sm">
                    {benefit.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}